import { useState } from "react";
import useAPI from "../../../../../api/hooks/useAPI";
import SoftButton from "../../../../../components/buttons/SoftButton";
import { ReactComponent as FlashIcon } from "../../../../../icons/icon_files/flash.svg";
import {
  IntegrationCategory,
  IntegrationsMapping,
} from "../../IntegrationsMapping";
import PotentialModal from "./PotentialModal";

export default function PotentialButton({
  integrationName,
  integrationsInfoQuery,
}) {
  const { trackEvent } = useAPI();
  const [showModal, setShowModal] = useState(false);

  const integrationDetails = IntegrationsMapping[integrationName];

  const shouldShow =
    integrationDetails &&
    (integrationDetails.collectable ||
      integrationDetails.scannable ||
      integrationDetails.hasVulnerabilityCollection ||
      [
        IntegrationCategory.TICKETING,
        IntegrationCategory.ALERTING,
        IntegrationCategory.AUTOMATION,
        IntegrationCategory.SIEM,
      ].includes(integrationDetails.category));

  if (!shouldShow) {
    return null;
  }

  return (
    <>
      <SoftButton
        onClick={() => {
          trackEvent(
            `User clicked the "What you get?" button to view the ${integrationName} potential modal`
          );
          setShowModal((prev) => !prev);
        }}
        color="primary"
        size="xs"
        icon={FlashIcon}
      >
        What you get?
      </SoftButton>
      <PotentialModal
        showModal={showModal}
        setShowModal={setShowModal}
        integrationName={integrationName}
        integrationsInfoQuery={integrationsInfoQuery}
      />
    </>
  );
}
